var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title',{attrs:{"pageTitle":_vm.$route.meta.title}}),_c('product-create',{attrs:{"goods_id":_vm.$route.params.goods_id || ''},on:{"success":_vm.onSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }